export default "__VITE_ASSET__7HEZQzSc__"